import React from 'react';
import { Link } from 'react-router-dom';
import QuantitySelector from '../commons/quantity-selector/QuantitySelector';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'
import CouponCode from '../commons/coupon/CouponCode';
import TipSelector from '../commons/tip-selector/TipSelector';

const BillDetails = ({ billDetails, onChangeTipPercent, onChangeCustomTipValue, viewMode, onApplyCoupon, discountMessage, onRemoveCoupon }) => {
  return (
    <table className="table bill-details-table table-responsive">
      <tfoot>
        <tr className="mobile-row">
          <td colSpan="2">
            <CouponCode onApplyCoupon={onApplyCoupon} onRemoveCoupon={onRemoveCoupon} discountMessage={discountMessage} discount={billDetails.discount} />
          </td>
        </tr>
        <tr className="mobile-row">
          <td>TOTAL</td>
          <td>
            <span className="price-text">{billDetails && billDetails.total
              ? `$${billDetails.total.toFixed(2)}`
              : 'N/A'}</span>
          </td>
        </tr>
        <tr className="desktop-row">
          <td>
            <CouponCode onApplyCoupon={onApplyCoupon} onRemoveCoupon={onRemoveCoupon} discountMessage={discountMessage} discount={billDetails.discount} />
          </td>
          <td>TOTAL</td>
          <td className={billDetails.discountByPromoCode ? "price-promo" : ""}>
            <span className="price-text">
              {billDetails && billDetails.total
                ? `$${billDetails.total.toFixed(2)} `
                : "N/A"}
            </span>

            {billDetails && billDetails.discountByPromoCode ? (
              <span className="promo-discount">
                {"Hurray, you saved " +
                  `$${billDetails.discountByPromoCode.toFixed(2)}`}
              </span>
            ) : (
                ""
              )}
          </td>
        </tr>
      </tfoot>
      <tbody>
        <tr className="bill-details-row desktop-row">
          <td className="title-col">&nbsp;</td>
          <td colSpan="2">
            {renderBillDetailsTable()}
          </td>
        </tr>
        <tr className="bill-details-row mobile-row">
          <td colSpan="2">
            {renderBillDetailsTable()}
          </td>
        </tr>
      </tbody>
    </table>
  );

  function renderBillDetailsTable() {

    return (
      <table>
        <tbody>
          {
            billDetails.discountByPromoCode ? (
              <tr>
                <td>
                  <span>DISCOUNT</span>
                  {billDetails.discount && billDetails.discount.discountType == 1 ?
                    <span> - FLAT ${billDetails.discountByPromoCode} OFF</span>
                    : <span> - {billDetails.discount.discount * 100}% OFF</span>
                  }
                </td>
                <td>
                  <span>(${billDetails.discountByPromoCode})</span>
                </td>
              </tr>
            )
              : null
          }

          <tr>
            <td>
              <span>CRV</span>
            </td>
            <td>
              <span>{billDetails && (billDetails.CRV || billDetails.CRV == 0)
                ? `$${billDetails.CRV.toFixed(2)}`
                : 'N/A'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>Subtotal</span>
            </td>
            <td>
              <span>{billDetails && billDetails.subTotal
                ? `$${billDetails.subTotal.toFixed(2)}`
                : 'N/A'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>Tax</span>
            </td>
            <td>
              <span>{billDetails && billDetails.tax
                ? `$${parseFloat(billDetails.tax).toFixed(2)}`
                : 'N/A'}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>Delivery Fee</span>
            </td>
            <td>
              <span>{billDetails && billDetails.deliveryFee
                ? `$${parseFloat(billDetails.deliveryFee).toFixed(2)}`
                : 'N/A'}</span>
            </td>
          </tr>
          {/*<tr>
            <td>
              <span>Delivery Fee</span>
            </td>
            <td>
              <span>{`$${ 3}`}</span>
            </td>
          </tr>*/}
          <tr className={viewMode && viewMode === 'edit' ? 'tip-selector-row' : null}>
            <td>
              <span className="tip-text">Tip</span>
              {viewMode && viewMode === 'edit'
                ? (<TipSelector percent={billDetails && billDetails.tip
                  ? billDetails.tip.percent
                  : 0} onChangeCustomValue={(v) => onChangeCustomTipValue(v)} onChangePercent={(p) => onChangeTipPercent(p)} />)
                : null}
            </td>
            <td>
              <span>{billDetails && (billDetails.tip || billDetails.tip == 0)
                ? `$${billDetails.tip.amount.toFixed(2)}`
                : 'N/A'}</span>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
};

export default BillDetails;



// WEBPACK FOOTER //
// ./src/components/cart/BillDetails.js